export const firebaseEnvironmentKey = async (key: string): Promise<string> => {
  const mountKey =
    (await process.env.VUE_APP_ENV_KEY) === "PRD"
      ? key
      : `${process.env.VUE_APP_ENV_KEY}_${key}`;
  if (mountKey) {
    return Promise.resolve(mountKey);
  }
  return Promise.reject();
};
